export default __webpack_public_path__ + "static/media/aman.8e3c32df.png";